// FILE: client/src/components/navbar/NavbarEntry.js
import React, { useEffect, useState } from "react";
import MainHeader from "./MainHeader";
import BottomHeader from "./BottomHeader";
import MobileHeader from "./MobileHeader";

export default function NavbarEntry({ breakpoint = 992 }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e) => setIsMobile(e.matches);

    setIsMobile(mq.matches);

    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, [breakpoint]);

  if (isMobile) return <MobileHeader />;

  return (
    <>
      <MainHeader />
      <BottomHeader />
    </>
  );
}
